import { ConditionApi } from 'cadenza/api-client/conditions/condition-api';
import type { CaseSensitivity } from 'cadenza/conditions/model/case-sensitivity';
import type { CombinationType } from 'cadenza/conditions/model/combination-type';
import type { FilterType } from 'cadenza/conditions/model/filter-type';

export class LikeConditionApi extends ConditionApi {

  // @ts-ignore -- the whole `setValue` interaction is unfortunate, but the way the API is used, this works.
  setValue (filterType: FilterType, caseSensitivity: CaseSensitivity, combinationType: CombinationType, likeExpressions: unknown[]) {
    const rows = likeExpressions.map(row => [ row ]);
    return super.setValue(rows, {
      filterType,
      caseSensitivity,
      combinationType
    });
  }

}
